import {
  actionTypes,
  createWorkflowFailure,
  createWorkflowStepConfigurationFailure,
  createWorkflowStepConfigurationSuccess,
  createWorkflowStepFailure,
  createWorkflowStepSuccess,
  createWorkflowSuccess,
  deleteWorkflowFailure,
  deleteWorkflowStepConfigurationFailure,
  deleteWorkflowStepConfigurationSuccess,
  deleteWorkflowStepFailure,
  deleteWorkflowStepSuccess,
  deleteWorkflowSuccess,
  getMatchingRulesRequestFailure,
  getMatchingRulesRequestSuccess,
  updateMatchingRulesFailure,
  updateMatchingRulesSuccess,
  updateWorkflowFailure,
  updateWorkflowStepConfigurationFailure,
  updateWorkflowStepConfigurationSuccess,
  updateWorkflowStepFailure,
  updateWorkflowStepSuccess,
  updateWorkflowSuccess,
  workflowRequestFailure,
  workflowRequestSuccess,
  workflowStepConfigurationRequestFailure,
  workflowStepConfigurationRequestSuccess,
  workflowStepRequestFailure,
  workflowStepRequestSuccess,
} from "./actions";

import {
  fetchCreateWorkflow,
  fetchCreateWorkflowStep,
  fetchCreateWorkflowStepConfiguration,
  fetchDeleteWorkflow,
  fetchDeleteWorkflowStep,
  fetchDeleteWorkflowStepConfiguration,
  fetchGetAllWorkflow,
  fetchGetAllWorkflowStep,
  fetchGetAllWorkflowStepConfiguration,
  fetchGetWorkflowRules,
  fetchModifyWorkflow,
  fetchModifyWorkflowRules,
  fetchModifyWorkflowStep,
  fetchModifyWorkflowStepConfiguration,
} from "./services";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchWorkflowRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.WORKFLOW_REQUEST),
    mergeMap(() =>
      fetchGetAllWorkflow().pipe(
        map((response: any) => workflowRequestSuccess(response)),
        catchError((error: any) => of(workflowRequestFailure(error)))
      )
    )
  );

const fetchWorkflowStepRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.WORKFLOW_STEP_REQUEST),
    mergeMap(() =>
      fetchGetAllWorkflowStep().pipe(
        map((response: any) => workflowStepRequestSuccess(response)),
        catchError((error: any) => of(workflowStepRequestFailure(error)))
      )
    )
  );

const fetchWorkflowStepConfigurationRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.WORKFLOW_STEP_CONFIGURATION_REQUEST),
    mergeMap(() =>
      fetchGetAllWorkflowStepConfiguration().pipe(
        map((response: any) =>
          workflowStepConfigurationRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(workflowStepConfigurationRequestFailure(error))
        )
      )
    )
  );

const fetchCreateWorkflowEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_WORKFLOW_REQUEST),
    mergeMap((action: any) =>
      fetchCreateWorkflow(action.payload).pipe(
        map((response: any) => createWorkflowSuccess(response)),
        catchError((error: any) => of(createWorkflowFailure(error)))
      )
    )
  );

const fetchCreateWorkflowStepEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_WORKFLOW_STEP_REQUEST),
    mergeMap((action: any) =>
      fetchCreateWorkflowStep(action.payload).pipe(
        map((response: any) => createWorkflowStepSuccess(response)),
        catchError((error: any) => of(createWorkflowStepFailure(error)))
      )
    )
  );

const fetchCreateWorkflowStepConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST),
    mergeMap((action: any) =>
      fetchCreateWorkflowStepConfiguration(action.payload).pipe(
        map((response: any) =>
          createWorkflowStepConfigurationSuccess(response)
        ),
        catchError((error: any) =>
          of(createWorkflowStepConfigurationFailure(error))
        )
      )
    )
  );

const fetchUpdateWorkflowEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_WORKFLOW_REQUEST),
    mergeMap((action: any) =>
      fetchModifyWorkflow(action.payload).pipe(
        map((response: any) => updateWorkflowSuccess(response)),
        catchError((error: any) => of(updateWorkflowFailure(error)))
      )
    )
  );

const fetchUpdateWorkflowStepEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_WORKFLOW_STEP_REQUEST),
    mergeMap((action: any) =>
      fetchModifyWorkflowStep(action.payload).pipe(
        map((response: any) => updateWorkflowStepSuccess(response)),
        catchError((error: any) => of(updateWorkflowStepFailure(error)))
      )
    )
  );

const fetchUpdateWorkflowStepConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST),
    mergeMap((action: any) =>
      fetchModifyWorkflowStepConfiguration(action.payload).pipe(
        map((response: any) =>
          updateWorkflowStepConfigurationSuccess(response)
        ),
        catchError((error: any) =>
          of(updateWorkflowStepConfigurationFailure(error))
        )
      )
    )
  );

const fetchDeleteWorkflowEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_WORKFLOW_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteWorkflow(action.payload).pipe(
        map((response: any) => deleteWorkflowSuccess(response)),
        catchError((error: any) => of(deleteWorkflowFailure(error)))
      )
    )
  );

const fetchDeleteWorkflowStepEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_WORKFLOW_STEP_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteWorkflowStep(action.payload).pipe(
        map((response: any) => deleteWorkflowStepSuccess(response)),
        catchError((error: any) => of(deleteWorkflowStepFailure(error)))
      )
    )
  );

const fetchDeleteWorkflowStepConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST),
    mergeMap((action: any) =>
      fetchDeleteWorkflowStepConfiguration(action.payload).pipe(
        map((response: any) =>
          deleteWorkflowStepConfigurationSuccess(response)
        ),
        catchError((error: any) =>
          of(deleteWorkflowStepConfigurationFailure(error))
        )
      )
    )
  );

const fetchGetRulesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_MATCHING_RULES_REQUEST),
    mergeMap((action: any) =>
      fetchGetWorkflowRules().pipe(
        map((response: any) => getMatchingRulesRequestSuccess(response)),
        catchError((error: any) => of(getMatchingRulesRequestFailure(error)))
      )
    )
  );

const fetchModifyRulesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_MATCHING_RULES),
    mergeMap((action: any) =>
      fetchModifyWorkflowRules(action.payload).pipe(
        map((response: any) => updateMatchingRulesSuccess(response)),
        catchError((error: any) => of(updateMatchingRulesFailure(error)))
      )
    )
  );

export default [
  fetchWorkflowRequestEpic,
  fetchWorkflowStepRequestEpic,
  fetchWorkflowStepConfigurationRequestEpic,
  fetchGetRulesEpic,
  fetchModifyRulesEpic,
  fetchCreateWorkflowEpic,
  fetchCreateWorkflowStepEpic,
  fetchCreateWorkflowStepConfigurationEpic,
  fetchUpdateWorkflowEpic,
  fetchUpdateWorkflowStepEpic,
  fetchUpdateWorkflowStepConfigurationEpic,
  fetchDeleteWorkflowEpic,
  fetchDeleteWorkflowStepEpic,
  fetchDeleteWorkflowStepConfigurationEpic,
];
